<script>
import { sendHelpTicket } from './services';
import CircularProgress from './CircularProgress.svelte';

let submitted = false;

let firstname = '';
let lastname = '';
let email = '';
let phone = '';
let company = '';
let message = '';

let errors = {}

let loading = false;
let error;

async function send() {
  const state = {
    firstname: firstname.trim(),
    lastname: lastname.trim(),
    email: email.trim(),
    phone: phone.trim(),
    company: company.trim(),
    message: message.trim()
  }

  errors = {}
  error = undefined;
  let hasError = false;

  if (state.firstname.length === 0) {
    errors['firstname'] = 'Please provide your first name'
    hasError = true;
  }

  if (state.lastname.length === 0) {
    errors['lastname'] = 'Please provide your last name'
    hasError = true;
  }

  if ((state.email || '').indexOf('@') === -1) {
    errors['email'] = 'Please provide a valid email address'
    hasError = true;
  }

  if (state.message.length === 0) {
    errors['message'] = 'Please enter your message'
    hasError = true;
  }

  if (!hasError) {
    loading = true;
    
    try {
      await sendHelpTicket(state);
      submitted = true;
    } catch (e) {
      error = e.message;
    } finally {
      loading = false;
    }
  }
}

</script>

<div class="section-header">HELP DESK</div>
    
<div class="container">
  <div class="title mb-8">Help desk request</div>

  {#if !submitted} 
    <div class="sub-text mb-16">If you are having any issues with our website such as logging in or accessing sessions please complete the help desk form below. If you have any questions or would like more information on the overall event please contact email@email.com</div>

    <div class="rowtocol">
      <div class="col f1">
        <div class='label'>First Name*</div>
        <input type='text' name="firstname" placeholder='First name' bind:value={firstname} />
        {#if errors['firstname']}
          <div class='error'>{errors['firstname']}</div>
        {/if}
      </div>
      <div class="gutter" />
      <div class="col f1">
        <div class='label'>Last Name*</div>
        <input type='text' name="lastname" placeholder='Last name' bind:value={lastname} />
        {#if errors['lastname']}
          <div class='error'>{errors['lastname']}</div>
        {/if}
      </div>
    </div>
    
    <div class="row">
      <div class="col f1">
        <div class='label'>Email*</div>
        <input type='email' name="email" placeholder='Email' bind:value={email} />
        {#if errors['email']}
          <div class='error'>{errors['email']}</div>
        {/if}
      </div>
    </div>

    <div class="rowtocol">
      <div class="col f1">
        <div class='label'>Phone Number</div>
        <input type='text' name="phone" placeholder='Phone number' bind:value={phone} />
      </div>
      <div class="gutter" />
      <div class="col f1">
        <div class='label'>Company</div>
        <input type='text' name="company" placeholder='Company' bind:value={company} />
      </div>
    </div>

    <div class="row">
      <div class="col f1">
        <div class='label'>Comments*</div>
        <textarea bind:value={message} />
        {#if errors['message']}
          <div class='error'>{errors['message']}</div>
        {/if}
      </div>
    </div>

    {#if error}
      <div class="error-box">
        {error}
      </div>
    {/if}

    <div class="row" style="justify-content: flex-end">
      {#if loading}
        <div style="margin: 8px 0">
          <CircularProgress color='var(--guardsmen-red)' />
        </div>
      {:else}
        <input disabled={loading} class="button live" type='button' value="SUBMIT" on:click={send} />
      {/if}
    </div>

  {:else}
    <h3>Submitted!</h3>

    <div>
      We will respond to your message as soon as possible.
    </div>
  {/if}
</div>

<style lang="scss">
@import './util';
@import './theme';

.title {
  font-size: 32px;
  font-weight: normal;
  text-transform: uppercase;
}
.label {
  margin-top: 12px;
}

textarea {
  width: 100%;
  height: 200px;
  padding: 6px;
}

.error {
  color: white;
  background-color: var(--guardsmen-red);
  align-self: flex-start;
  padding: 2px 4px;
  border-radius: 3px;
  margin-left: 2px;
  margin-top: 2px;
}

.container {
  background-color: $help-desk-background-color;
  color: $help-desk-foreground-color;
  padding: 36px;
  max-width: 800px;

  @include landscape {
    width: 100%;
  }
}

.sub-text {
  font-size: 16px;
  font-weight: 300;
  opacity: .5;
}
</style>